import { render, staticRenderFns } from "./FaceGroupSearch.vue?vue&type=template&id=5de6f5cc&scoped=true&"
import script from "./FaceGroupSearch.vue?vue&type=script&lang=js&"
export * from "./FaceGroupSearch.vue?vue&type=script&lang=js&"
import style0 from "./FaceGroupSearch.vue?vue&type=style&index=0&id=5de6f5cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de6f5cc",
  null
  
)

export default component.exports